"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactHookForm = require("react-hook-form");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _atoms = require("../components/atoms");

var _excluded = ["control", "name", "label", "noMt", "containerClassName", "hideLabel", "initialDirty"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var withFormState = function withFormState(Component) {
  function WrappedChildren(props) {
    var control = props.control,
        name = props.name,
        label = props.label,
        _props$noMt = props.noMt,
        noMt = _props$noMt === void 0 ? false : _props$noMt,
        _props$containerClass = props.containerClassName,
        containerClassName = _props$containerClass === void 0 ? '' : _props$containerClass,
        _props$hideLabel = props.hideLabel,
        hideLabel = _props$hideLabel === void 0 ? false : _props$hideLabel,
        _props$initialDirty = props.initialDirty,
        initialDirty = _props$initialDirty === void 0 ? false : _props$initialDirty,
        rest = _objectWithoutProperties(props, _excluded);

    var _useState = (0, _react.useState)(false),
        _useState2 = _slicedToArray(_useState, 2),
        hasValue = _useState2[0],
        setHasValue = _useState2[1];

    var _useController = (0, _reactHookForm.useController)({
      name: name,
      control: control
    }),
        field = _useController.field,
        _useController$fieldS = _useController.fieldState,
        invalid = _useController$fieldS.invalid,
        isTouched = _useController$fieldS.isTouched,
        error = _useController$fieldS.error,
        isDirtyField = _useController$fieldS.isDirty;
    /*
      This field is provided by withForm hook.
       If you want use this hoc outside of withForm you need use the FormProvider of react-hook-form and pass defaultValues field
    */


    var _useFormContext = (0, _reactHookForm.useFormContext)(),
        _useFormContext$defau = _useFormContext.defaultValues,
        defaultValues = _useFormContext$defau === void 0 ? _defineProperty({}, name, '') : _useFormContext$defau;

    var defaultValue = defaultValues[name];
    var isDirty = (0, _react.useMemo)(function () {
      return isDirtyField || defaultValue !== '' || initialDirty || defaultValue !== field.value;
    }, [isDirtyField, defaultValue, initialDirty, field.value]);
    (0, _react.useEffect)(function () {
      setHasValue(isTouched && isDirty && field.value && field.value !== '');
    }, [isTouched, isDirty, field.value]);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(!noMt && 'mt-2', containerClassName)
    }, !hideLabel && /*#__PURE__*/_react.default.createElement(_atoms.FieldLabel, {
      hasValue: hasValue || invalid,
      hasError: invalid
    }, label), /*#__PURE__*/_react.default.createElement(Component, _extends({}, rest, field, {
      hasValue: isTouched && isDirty,
      hasError: invalid,
      className: "mt-1"
    })), invalid && error && /*#__PURE__*/_react.default.createElement(_atoms.ErrorLabel, null, error.message));
  }

  WrappedChildren.propTypes = {
    control: _propTypes.default.any.isRequired,
    name: _propTypes.default.string.isRequired,
    label: _propTypes.default.string,
    noMt: _propTypes.default.bool,
    containerClassName: _propTypes.default.string,
    hideLabel: _propTypes.default.bool,
    initialDirty: _propTypes.default.bool
  };
  return WrappedChildren;
};

var _default = withFormState;
exports.default = _default;